import { Injectable } from '@angular/core';
import { IFormConfig } from '@shared/configurable/models/IFormConfig';
import { EFormConfig } from '@shared/enums/EFormConfig';
import { BaseApiService } from '@api/base-api.service';

@Injectable({
  providedIn: 'root',
})
export class FormSettingsApiService extends BaseApiService {
  protected override path = 'group';

  // DESC: Get group form settings
  public getSettings(formType: EFormConfig | 0 = 0) {
    return this.get<IFormConfig[]>('form-settings', { formType });
  }

  // DESC: Update group form settings
  public updateSettings(data: IFormConfig[]) {
    return this.post<null>('form-settings', { data: data });
  }
}
